(function () {
  'use strict';

  angular.module('app').component('associatedServiceItemList', associatedServiceItemList());

  function associatedServiceItemList() {
    return {
      bindings: {
        product: '<',
        productType: '@',
        associatedServiceItems: '=',
        onAssociatedServiceItemSaved: '&',
        onAssociatedServiceItemDeleted: '&',
      },
      controller: AssociatedServiceItemListsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/service-items/associated-service-items/associated-service-item-list/' +
        'associated-service-item-list.component.html',
    };
  }

  AssociatedServiceItemListsComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AssociatedServiceItemService',
    'ServiceItemService',
    'ServiceItemCostService',
  ];

  function AssociatedServiceItemListsComponent(
    config,
    UtilService,
    SessionService,
    AssociatedServiceItemService,
    ServiceItemService,
    ServiceItemCostService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    var fieldsDefinition = [
      'provider_id',
      'provider',
      'service_item',
      'service_item_id',
      'appliedTo',
    ];

    vm.addAssociatedServiceItem = addAssociatedServiceItem;
    vm.removeAssociatedServiceItem = removeAssociatedServiceItem;
    vm.selectServiceItem = selectServiceItem;
    vm.selectProvider = selectProvider;
    vm.openAsociatedServiceItemModal = openAsociatedServiceItemModal;
    vm.openServiceItemCostsModal = openServiceItemCostsModal;

    vm.saveAssociatedServiceItem = saveAssociatedServiceItem;
    vm.deleteAssociatedServiceItem = deleteAssociatedServiceItem;
    vm.editAssociatedServiceItem = editAssociatedServiceItem;

    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      // Initializers
      getServiceItems();
    };

    function getServiceItems() {
      var params = {
        get: 'active',
        by_product_type: vm.productType,
        search: true,
        providers: true,
        skip_check_role: true,
      };

      vm.loadingServiceItems = true;
      ServiceItemService.getServiceItems(params).then(function (data) {
        vm.serviceItems = data.items;
        vm.loadingServiceItems = false;

        // console.log(vm.serviceItems);
        // console.log(vm.associatedServiceItems);

        getAvailableServiceItems();
      });
    }

    function getAvailableServiceItems() {
      var associatedServiceItems = AssociatedServiceItemService.setAssociatedServiceItems(
        vm.associatedServiceItems
      );

      vm.availableServiceItems = vm.UtilService.getAvailableItemsInTwoArrays(
        vm.serviceItems,
        associatedServiceItems,
        'id'
      );
    }

    function addAssociatedServiceItem() {
      vm.addMode = true;
      vm.associatedServiceItems.push({});

      vm.formErrors = false;
    }

    function removeAssociatedServiceItem(index) {
      vm.addMode = false;
      vm.associatedServiceItems.splice(index, 1);
    }

    // for product associated service items
    function openServiceItemCostsModal(associatedServiceItem) {
      let successCallback = (dataObj) => {
        console.log(dataObj);

        associatedServiceItem.service_item.current_costs = {
          rates_today: dataObj.rates_today,
          rates_updated_until: dataObj.rates_updated_until,
          currency: dataObj.currency,
        };
      };

      var provider = associatedServiceItem.provider;

      if (provider.associability_id) {
        provider = associatedServiceItem.provider.provider;
      }

      ServiceItemCostService.openServiceItemCostsModal(
        associatedServiceItem.service_item,
        provider,
        'provider',
        userLanguageCode,
        successCallback
      );
    }

    function selectServiceItem(associatedServiceItem, serviceItem) {
      associatedServiceItem.service_item = serviceItem;
    }
    function selectProvider(associatedServiceItem, serviceItemAssociatedProvider) {
      associatedServiceItem.provider = serviceItemAssociatedProvider.provider;
    }

    function openAsociatedServiceItemModal(associatedServiceItem) {
      var successCallback = function () {
        // data
        vm.onAssociatedServiceItemSaved({ items: vm.associatedServiceItems });
      };

      AssociatedServiceItemService.openAsociatedServiceItemModal(
        associatedServiceItem,
        vm.productType,
        vm.product,
        successCallback
      );
    }

    // Create/Update
    function saveAssociatedServiceItem(associatedServiceItem, isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
      } else {
        vm.sendingForm = true;

        associatedServiceItem.product_associated_id = vm.product.id;

        if (!associatedServiceItem.id) {
          // Create
          if (vm.productType === 'tour') {
            associatedServiceItem.associated_service_item_schedules =
              setAssociatedServiceItemSchedules(vm.product.tour_options);
          }
        }

        // console.log(associatedServiceItem); return;

        AssociatedServiceItemService.saveAssociatedServiceItem(
          associatedServiceItem,
          vm.productType
        ).then(function () {
          var status = AssociatedServiceItemService.status;
          var response = AssociatedServiceItemService.response;

          if (status) {
            // Success
            if (!associatedServiceItem.id) {
              // Create
              associatedServiceItem.id = response.id;
              associatedServiceItem.product_associated_id = vm.product.id;
              associatedServiceItem.service_item = response.service_item;

              if (vm.productType === 'tour') {
                associatedServiceItem.appliedTo = response.appliedTo;
                associatedServiceItem.associated_service_item_schedules =
                  response.associated_service_item_schedules;
              }
            }

            associatedServiceItem.editMode = false;

            vm.onAssociatedServiceItemSaved({ items: vm.associatedServiceItems });

            getAvailableServiceItems();
          }

          vm.addMode = false;
          vm.sendingForm = false;
        });
      }
    }

    function deleteAssociatedServiceItem(serviceItem) {
      // , index
      var successCallback = function (idx) {
        idx = vm.associatedServiceItems.indexOf(serviceItem);
        removeAssociatedServiceItem(idx);
        getAvailableServiceItems();

        vm.onAssociatedServiceItemDeleted({ items: vm.associatedServiceItems });
      };

      AssociatedServiceItemService.deleteAssociatedServiceItem(
        serviceItem.id,
        vm.productType,
        successCallback
      ); // , index
    }

    function editAssociatedServiceItem(associatedServiceItem) {
      associatedServiceItem.editMode = !associatedServiceItem.editMode;

      if (!associatedServiceItem.editMode) {
        // Undo changes
        _restoreOriginalValues(associatedServiceItem);
      } else {
        // save server name to restore it if the user cancel edition
        associatedServiceItem.originalValues = angular.toJson(associatedServiceItem);
      }
    }

    function _restoreOriginalValues(associatedServiceItem) {
      var serverItem = angular.fromJson(associatedServiceItem.originalValues);

      fieldsDefinition.forEach(function (field) {
        associatedServiceItem[field] = serverItem[field];
      });
    }

    // Enable all schedules on creation
    function setAssociatedServiceItemSchedules(tourOptions) {
      var associatedServiceItemSchedules = [];

      tourOptions.forEach(function (tourOption) {
        tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
          let schedule = {
            tour_id: vm.product.id,
            tour_option_id: tourOption.id,
            tour_option_schedule_id: tourOptionSchedule.id,
            // departure: tourOptionSchedule.departure,
            status: tourOptionSchedule.status,
            enabled: true,
          };

          associatedServiceItemSchedules.push(schedule);
        });
      });

      return associatedServiceItemSchedules;
    }
  }
})();
